import CTNAvatar from '@ctn/ui/components/ctn-avatar';
import { type ReactElement } from 'react';

import GoogleMapsWrapper from '@/context/Maps/googleMapsWrapper.context';

import { type INotaria } from '@/interfaces/model/TramiteNuevo/INotaria.interface';

import MapComponent from './MapComponent';


type NotaryDataProps = {
	readonly data: INotaria;
	readonly isShowMap?: boolean;
};

const NotaryData = ({ data, isShowMap = true }: NotaryDataProps): ReactElement => {
	const mapOptions = {
		center: {
			lat: parseFloat(data?.notariaCoordenadas?.latitud) || '',
			lng: parseFloat(data?.notariaCoordenadas?.longitud) || '',
		},
		zoom: 10,
		gestureHandling: 'none',
		disableDefaultUI: true,
		streetViewControl: false,
		codigoNotarioNotaria: data?.codigoNotarioNotaria,
	};

	return (
		<div className="c-pnp-notary-data">
			<div className="c-pnp-notary-data__wrapper">
				<div className="c-pnp-notary-data__img">
					<CTNAvatar type='basic' image={data.notarioImagen ? `data:image/png;base64, ${data.notarioImagen}` : undefined} />
				</div>

				<div className="c-pnp-notary-data__profile">
					<p className="c-pnp-notary-data__name">
						{data.notarioNombre} {data.notarioApellidos}
					</p>
					<p className="c-pnp-notary-data__text">
						{`${'Dirección:'}`} {data.notarioDireccion}
					</p>
					{data.notarioTelefono && (
						<p className="c-pnp-notary-data____text">
							Teléfono: {data.notarioTelefono}
						</p>
					)}
					{data.notarioEmail && (
						<p className="c-pnp-notary-data____text">
							{'Email notaría:'}{' '}
							<a
								className="c-pnp-notary-data__link"
								href={`mailto:${data.notarioEmail}`}
							>
								{data.notarioEmail}
							</a>
						</p>
					)}
					{data.notarioEmailPersonal && (
						<p className="c-pnp-notary-data__text">
							{'Email personal:'}{' '}
							<a
								className="c-pnp-notary-data__link"
								href={`mailto:${data.notarioEmailPersonal}`}
							>
								{data.notarioEmailPersonal}
							</a>
						</p>
					)}
				</div>
			</div>
			{isShowMap && data.notariaCoordenadas && (
				<div className="c-pnp-notary-data__location">
					<GoogleMapsWrapper>
						<MapComponent mapOptions={mapOptions} />
					</GoogleMapsWrapper>
				</div>
			)}
		</div>
	);
};

export default NotaryData;
